export const yatAbi = [
    {
        inputs: [{ internalType: 'address', name: '_signer', type: 'address' }],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'approved', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'owner', type: 'address' },
            { indexed: true, internalType: 'address', name: 'operator', type: 'address' },
            { indexed: false, internalType: 'bool', name: 'approved', type: 'bool' },
        ],
        name: 'ApprovalForAll',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
        ],
        name: 'Burn',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { indexed: true, internalType: 'address', name: 'account', type: 'address' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
        ],
        name: 'Mint',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'manager', type: 'address' },
            { indexed: true, internalType: 'bytes32', name: 'keyHash', type: 'bytes32' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
            { indexed: false, internalType: 'string', name: 'key', type: 'string' },
        ],
        name: 'RecordAdded',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'manager', type: 'address' },
            { indexed: true, internalType: 'bytes32', name: 'keyHash', type: 'bytes32' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
            { indexed: false, internalType: 'string', name: 'key', type: 'string' },
        ],
        name: 'RecordDeleted',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: true, internalType: 'address', name: 'manager', type: 'address' },
            { indexed: true, internalType: 'bytes32', name: 'keyHash', type: 'bytes32' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
            { indexed: false, internalType: 'string', name: 'key', type: 'string' },
            { indexed: false, internalType: 'string', name: 'value', type: 'string' },
        ],
        name: 'RecordUpdated',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            { indexed: true, internalType: 'uint256', name: 'tokenId', type: 'uint256' },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            { indexed: true, internalType: 'address', name: 'from', type: 'address' },
            { indexed: true, internalType: 'address', name: 'to', type: 'address' },
            { indexed: true, internalType: 'bytes32', name: 'tokenHash', type: 'bytes32' },
            { indexed: false, internalType: 'string', name: 'token', type: 'string' },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
        name: 'allInfoFor',
        outputs: [
            { internalType: 'uint256', name: 'supply', type: 'uint256' },
            { internalType: 'uint256', name: 'ownerBalance', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_approved', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'approve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
        name: 'balanceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'baseTokenURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'burn',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'contractURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'cosignerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'deleteAllRecords',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'string', name: '_key', type: 'string' },
        ],
        name: 'deleteRecord',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'getApproved',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'bytes32', name: '_hash', type: 'bytes32' },
        ],
        name: 'getFullRecord',
        outputs: [
            { internalType: 'string', name: '', type: 'string' },
            { internalType: 'string', name: '', type: 'string' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes32', name: '_hash', type: 'bytes32' }],
        name: 'getKey',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_owner', type: 'address' },
            { internalType: 'uint256', name: '_limit', type: 'uint256' },
            { internalType: 'uint256', name: '_page', type: 'uint256' },
            { internalType: 'bool', name: '_isAsc', type: 'bool' },
        ],
        name: 'getOwnerYATsTable',
        outputs: [
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
            { internalType: 'bytes32[]', name: 'tokens', type: 'bytes32[]' },
            { internalType: 'address[]', name: 'cosigners', type: 'address[]' },
            { internalType: 'address[]', name: 'pointers', type: 'address[]' },
            { internalType: 'address[]', name: 'approveds', type: 'address[]' },
            { internalType: 'uint256', name: 'totalYATs', type: 'uint256' },
            { internalType: 'uint256', name: 'totalPages', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'string', name: '_key', type: 'string' },
        ],
        name: 'getRecord',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: '_token', type: 'string' },
            { internalType: 'string', name: '_key', type: 'string' },
        ],
        name: 'getRecord',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'bytes32', name: '_hash', type: 'bytes32' },
        ],
        name: 'getRecord',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'bytes32[]', name: '_hashes', type: 'bytes32[]' },
        ],
        name: 'getRecords',
        outputs: [
            { internalType: 'bytes32[]', name: 'values', type: 'bytes32[]' },
            { internalType: 'bool[]', name: 'trimmed', type: 'bool[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'uint256', name: '_limit', type: 'uint256' },
            { internalType: 'uint256', name: '_page', type: 'uint256' },
            { internalType: 'bool', name: '_isAsc', type: 'bool' },
        ],
        name: 'getRecordsTable',
        outputs: [
            { internalType: 'bytes32[]', name: 'hashes', type: 'bytes32[]' },
            { internalType: 'bytes32[]', name: 'keys', type: 'bytes32[]' },
            { internalType: 'bool[]', name: 'keysTrimmed', type: 'bool[]' },
            { internalType: 'bytes32[]', name: 'values', type: 'bytes32[]' },
            { internalType: 'bool[]', name: 'valuesTrimmed', type: 'bool[]' },
            { internalType: 'uint256', name: 'totalRecords', type: 'uint256' },
            { internalType: 'uint256', name: 'totalPages', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'getYAT',
        outputs: [
            { internalType: 'string', name: 'token', type: 'string' },
            { internalType: 'address', name: 'tokenOwner', type: 'address' },
            { internalType: 'address', name: 'tokenCosigner', type: 'address' },
            { internalType: 'address', name: 'pointer', type: 'address' },
            { internalType: 'address', name: 'approved', type: 'address' },
            { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            { internalType: 'uint256', name: 'records', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: '_token', type: 'string' }],
        name: 'getYAT',
        outputs: [
            { internalType: 'uint256', name: 'tokenId', type: 'uint256' },
            { internalType: 'address', name: 'tokenOwner', type: 'address' },
            { internalType: 'address', name: 'tokenCosigner', type: 'address' },
            { internalType: 'address', name: 'pointer', type: 'address' },
            { internalType: 'address', name: 'approved', type: 'address' },
            { internalType: 'uint256', name: 'nonce', type: 'uint256' },
            { internalType: 'uint256', name: 'records', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256[]', name: '_tokenIds', type: 'uint256[]' }],
        name: 'getYATs',
        outputs: [
            { internalType: 'bytes32[]', name: 'tokens', type: 'bytes32[]' },
            { internalType: 'address[]', name: 'owners', type: 'address[]' },
            { internalType: 'address[]', name: 'cosigners', type: 'address[]' },
            { internalType: 'address[]', name: 'pointers', type: 'address[]' },
            { internalType: 'address[]', name: 'approveds', type: 'address[]' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_limit', type: 'uint256' },
            { internalType: 'uint256', name: '_page', type: 'uint256' },
            { internalType: 'bool', name: '_isAsc', type: 'bool' },
        ],
        name: 'getYATsTable',
        outputs: [
            { internalType: 'uint256[]', name: 'tokenIds', type: 'uint256[]' },
            { internalType: 'bytes32[]', name: 'tokens', type: 'bytes32[]' },
            { internalType: 'address[]', name: 'owners', type: 'address[]' },
            { internalType: 'address[]', name: 'cosigners', type: 'address[]' },
            { internalType: 'address[]', name: 'pointers', type: 'address[]' },
            { internalType: 'address[]', name: 'approveds', type: 'address[]' },
            { internalType: 'uint256', name: 'totalYATs', type: 'uint256' },
            { internalType: 'uint256', name: 'totalPages', type: 'uint256' },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: '_token', type: 'string' }],
        name: 'hashOf',
        outputs: [{ internalType: 'bytes32', name: '', type: 'bytes32' }],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: '_token', type: 'string' }],
        name: 'idOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_owner', type: 'address' },
            { internalType: 'address', name: '_operator', type: 'address' },
        ],
        name: 'isApprovedForAll',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'string', name: '_token', type: 'string' },
            { internalType: 'address', name: '_account', type: 'address' },
            { internalType: 'uint256', name: '_expiry', type: 'uint256' },
            { internalType: 'bytes', name: '_signature', type: 'bytes' },
        ],
        name: 'mint',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'nonceOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'ownerOf',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'pointsTo',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'recordsOf',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'resetCosigner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_account', type: 'address' }],
        name: 'resolve',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_resolvesTo', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'resolveTo',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'string', name: '_token', type: 'string' }],
        name: 'reverseResolve',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'revokeCosigner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_from', type: 'address' },
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_from', type: 'address' },
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'bytes', name: '_data', type: 'bytes' },
        ],
        name: 'safeTransferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_operator', type: 'address' },
            { internalType: 'bool', name: '_approved', type: 'bool' },
        ],
        name: 'setApprovalForAll',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_cosigner', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'setCosigner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'contract Metadata', name: '_metadata', type: 'address' }],
        name: 'setMetadata',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_owner', type: 'address' }],
        name: 'setOwner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_pointsTo', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'setPointsTo',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'address', name: '_signer', type: 'address' }],
        name: 'setSigner',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'signer',
        outputs: [{ internalType: 'address', name: '', type: 'address' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'bytes4', name: '', type: 'bytes4' }],
        name: 'supportsInterface',
        outputs: [{ internalType: 'bool', name: '', type: 'bool' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_index', type: 'uint256' }],
        name: 'tokenByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'tokenOf',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_owner', type: 'address' },
            { internalType: 'uint256', name: '_index', type: 'uint256' },
        ],
        name: 'tokenOfOwnerByIndex',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'tokenURI',
        outputs: [{ internalType: 'string', name: '', type: 'string' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [{ internalType: 'uint256', name: '', type: 'uint256' }],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'address', name: '_from', type: 'address' },
            { internalType: 'address', name: '_to', type: 'address' },
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
        ],
        name: 'transferFrom',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [{ internalType: 'uint256', name: '_tokenId', type: 'uint256' }],
        name: 'unresolve',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'string', name: '_key', type: 'string' },
            { internalType: 'string', name: '_value', type: 'string' },
            { internalType: 'bytes', name: '_signature', type: 'bytes' },
        ],
        name: 'updateRecord',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            { internalType: 'uint256', name: '_tokenId', type: 'uint256' },
            { internalType: 'string', name: '_key', type: 'string' },
            { internalType: 'string', name: '_value', type: 'string' },
        ],
        name: 'updateRecord',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
] as const;
